import AchievementsList from "../views/AchievementsList.vue"
import AchievementCreate from "../views/AchievementCreate.vue"
import AchievementDetails from "../views/AchievementDetails.vue"

export default [
	{
		path: "/:tenantId/achievements",
		component: AchievementsList,
		meta: { featureId: "achievements" },
		name: "AchievementsList"
	},
	{
		path: "/:tenantId/achievements/create",
		component: AchievementCreate,
		meta: { featureId: "achievements" },
		name: "AchievementCreate",
		props: true
	},
	{
		path: "/:tenantId/achievements/details/:id",
		component: AchievementDetails,
		meta: { featureId: "achievements" },
		name: "AchievementDetails",
		props: true
	}
]
